type BadgeColor = 'blue' | 'green' | 'red' | 'orange' | 'gray' | 'yellow' | 'purple' | 'indigo'
    | 'pink' | 'olive' | 'teal' | 'gold' | 'todo' | 'turquoise';

export const INVOICE_STATUS_COLORS: Record<string, BadgeColor> = {
    OPEN: 'gold',
    PAID: 'green',
    CANCELLED: 'red',
    PARTIALLY_PAID: 'olive',
};

export const invoiceStatusColor = (status?: string | null): BadgeColor =>
    (status && INVOICE_STATUS_COLORS[status]) || 'gray';
